import {ObjectOfAny} from '@fo/shared-types';

type ObjectType = {[key: string]: ObjectType};

const flattenObject = (objectToFlatten = {}): ObjectOfAny => {
  const result = {} as ObjectOfAny;

  const flatten = (object: ObjectType, prefix = '', suffix = '') => {
    if (object === null) {
      const nullKey = prefix.slice(0, -1); // get everything except the `.`
      result[nullKey] = object;
      return;
    }
    Object.keys(object).forEach((key) => {
      const value = object[key];
      const path = `${prefix}${key}${suffix}`;

      if (Array.isArray(value)) {
        flatten(value, `${path}[`, ']');
      } else if (typeof value === 'object') {
        flatten(value, `${path}.`);
      } else {
        result[path] = value;
      }
    });
  };

  flatten(objectToFlatten);

  return result;
};

export default flattenObject;
